import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  filterTreeSelect: {
    width: '600px',
    maxHeight: '600px',
    overflow: 'auto'
  },

  filtersCollapse: {
    '.ant-collapse-header': {
      padding: '0px !important'
    }
  },

  selectedValue: {
    paddingLeft: 8
  },

  treeSelectMenu: {
    borderInlineEnd: 'none !important',

    '.ant-menu-sub': {
      background: 'inherit !important'
    },
    '.ant-menu-submenu-title': {
      marginBlock: '0px'
    },
    '.ant-menu-item': {
      marginBlock: '0px'
    }
  },

  filterCollapseButton: {
    '.ant-btn-icon': {
      color: 'white !important'
    }
  }
}))
